import { normalizeStringForComparison as normalizeString } from "@lib/helpers";

const getAvailableCitiesInRegion = ({ region, data }) => {
  if (!region || data?.length === 0) {
    return [];
  }

  const citiesWithLockers = new Set();

  data.forEach((marker) => {
    if (normalizeString(marker.address?.county) === normalizeString(region)) {
      citiesWithLockers.add(marker.address.locality);
    }
  });

  return Array.from(citiesWithLockers).sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
};

export default getAvailableCitiesInRegion;
